<h5 class="inner-heading">Documents Checklist</h5>

<mat-card>
  <app-document-list (removeElement)="deleteDocumentHandler($event)"></app-document-list>
</mat-card>